import * as sdk from "@kaggle/sdk";
import { competitionsClient as realCompetitionsClient } from "@kaggle/sdk/competitions";
import { educationClient as realEducationClient } from "@kaggle/sdk/education";
import { usersClient as realUsersClient } from "@kaggle/sdk/users";
import {
  SaveDraftRequest,
  SaveDraftResponse,
} from "../kernels/editor/draft/saveDraft";
import { Services } from "../kernels/types/Services";
import WebpackWindow from "../types/WebpackWindow";
import adhocClientApi from "./adhocClient";
import { kernelStorageClient } from "./createKernelStorageClient";
import adhocClientApiStub from "./stub/adhocClient";

export type KernelsClient = typeof sdk.kernelsClient;
export type DatasetsClient = typeof sdk.datasetsClient;
export type CompetitionsClient = typeof realCompetitionsClient;
export type SearchClient = typeof sdk.searchClient;
export type TagsClient = typeof sdk.tagsClient;
export type UsersClient = typeof realUsersClient;
export type UserSecretsClient = typeof sdk.userSecretsClient;
export type EducationClient = typeof realEducationClient;
export type AnalyticsClient = sdk.AnalyticsClient;
export interface AdhocClient {
  /**
   * Legacy method to view a CompetitionCard list.
   */
  viewCompetitionsList: (
    category: string,
    page: number | undefined,
    search: string,
    sortBy: string,
    tab: string
  ) => Promise<any>;

  saveDraft: (request: SaveDraftRequest) => Promise<SaveDraftResponse>;

  /** Sends keep-alive to back-end. */
  sendKeepAlive: (url: string) => Promise<any>;
}

export type { Services };

const webpackWindow = window as unknown as WebpackWindow;

const stubSdk = webpackWindow.__MOCK_SERVICES__
  ? // tslint:disable-next-line
    require("./stub/sdk")
  : sdk;

export const kernelsClient: KernelsClient = (window as unknown as WebpackWindow)
  .__MOCK_SERVICES__
  ? stubSdk.kernelsClient
  : sdk.kernelsClient;

export const competitionsClient: CompetitionsClient = (
  window as unknown as WebpackWindow
).__MOCK_SERVICES__
  ? stubSdk.competitionsClient
  : realCompetitionsClient;

export const datasetsClient: DatasetsClient = (
  window as unknown as WebpackWindow
).__MOCK_SERVICES__
  ? stubSdk.datasetsClient
  : sdk.datasetsClient;

export const usersClient: UsersClient = (window as unknown as WebpackWindow)
  .__MOCK_SERVICES__
  ? stubSdk.usersClient
  : realUsersClient;

export const searchClient: SearchClient = (window as unknown as WebpackWindow)
  .__MOCK_SERVICES__
  ? stubSdk.searchClient
  : sdk.searchClient;

export const tagsClient: TagsClient = (window as unknown as WebpackWindow)
  .__MOCK_SERVICES__
  ? stubSdk.tagsClient
  : sdk.tagsClient;

export const userSecretsClient: UserSecretsClient = (
  window as unknown as WebpackWindow
).__MOCK_SERVICES__
  ? stubSdk.userSecretsClient
  : sdk.userSecretsClient;

export const educationClient: EducationClient = (
  window as unknown as WebpackWindow
).__MOCK_SERVICES__
  ? stubSdk.educationClient
  : realEducationClient;

export const adhocClient: AdhocClient = webpackWindow.__MOCK_SERVICES__
  ? adhocClientApiStub
  : adhocClientApi;

export const analyticsClient: AnalyticsClient = {
  logger: sdk.logger,
};

export { kernelStorageClient };
